@if (Note) {
  <div class="modal-header">
    <h3 class="mb-0">{{ Note.title }}</h3>
    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      (click)="close()"
    ></button>
  </div>

  <div class="modal-body">
    <div class="note-meta-label">Note</div>
    <p class="whitespace-prewrap note-body mb-0">{{ Note.note }}</p>
  </div>

  <div class="modal-footer">
    <div class="action-row justify-end w-100">
      <button type="button" class="btn btn-primary" (click)="close()">
        Close
      </button>
    </div>
  </div>
}
